/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState, memo, type FunctionComponent } from 'react';
import Slider from '@mui/material/Slider';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import VolumeOff from '@mui/icons-material/VolumeOff';
import VolumeUp from '@mui/icons-material/VolumeUp';

import { IAudioPlayerColors, Icons } from '../types';
import PLAYER from './state/player';

// TODO: Restore makeStyles functionality

interface IPlayerVolume {
    status: string;
    value: number;
}

interface IAudioDownloadsControl {
    playerColors: IAudioPlayerColors;
    volume: IPlayerVolume;
    muted?: boolean | null;
    muteAudio: () => void;
    unmuteAudio: () => void;
    changeAudioVolume: (value: any) => void;
    icons?: Icons;
    classNames?: any;
}

export const AudioVolumeControl: FunctionComponent<IAudioDownloadsControl> = ({
    muted = null,
    muteAudio,
    unmuteAudio,
    volume,
    changeAudioVolume,
    icons = {},
}) => {
    // const classes = useComponentStyles({ playerColors });
    const { VolumeUpIcon = VolumeUp, VolumeOffIcon = VolumeOff } = icons;
    const handleVolumeChange = (event: object, value: any) => {
        changeAudioVolume(value);
    };
    const [volumeSlider, openVolumeSlider] = useState(false);
    const toggleVolumeSlider = (value: boolean) => () => {
        openVolumeSlider(value);
    };

    return (
        <Grid onMouseEnter={toggleVolumeSlider(true)} onMouseLeave={toggleVolumeSlider(false)}>
            {volume.status === PLAYER.VOLUME.STATUS.UNMUTE ? (
                <VolumeUpIcon
                    fontSize="large"
                    onClick={typeof muted !== 'boolean' ? muteAudio : () => {}}
                />
            ) : (
                <VolumeOffIcon
                    fontSize="large"
                    onClick={typeof muted !== 'boolean' ? unmuteAudio : () => {}}
                />
            )}
            {volumeSlider && (
                <Paper>
                    <Slider
                        orientation="vertical"
                        aria-labelledby="volume-control"
                        value={volume.value}
                        defaultValue={PLAYER.VOLUME.DEFAULT_VALUE}
                        onChange={handleVolumeChange}
                    />
                </Paper>
            )}
        </Grid>
    );
};

export default memo(AudioVolumeControl);
